import { render, staticRenderFns } from "./LimitedVideoModalSection.vue?vue&type=template&id=5685d6a2&scoped=true"
import script from "./LimitedVideoModalSection.vue?vue&type=script&lang=ts"
export * from "./LimitedVideoModalSection.vue?vue&type=script&lang=ts"
import style0 from "./LimitedVideoModalSection.vue?vue&type=style&index=0&id=5685d6a2&prod&lang=scss"
import style1 from "./LimitedVideoModalSection.vue?vue&type=style&index=1&id=5685d6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685d6a2",
  null
  
)

export default component.exports